import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalGeneric from "../../../Common/ModalGeneric";
import UpdateOpenModal from "../../CreateModals/UpdateOpenModal";
import OvertredelseskoderMiljogebyrUpdateModalContent from "../../OvertredelseskoderMiljogebyrForm";

import { putOvertredelseskoderMiljogebyr } from "../../../../actions/overtredelseskoderMiljogebyrActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../../utils/validationUtils";

const rules = {
  id: "required;isDigit",
  paragraf: "required;hasFormat=^.+ §.+$,1.3 §3-7",
  del: "required",
  belop: "required;isDigit",
  kortTekst: "required",
  langTekst: "required",
  arkivKode: "required",
  overtredelseGruppeId: "required",
  aktivertDato: "required;isDato;isLessThan=deaktivertDato",
  deaktivertDato: "required;isDato;isFuture;isLargerThan=aktivertDato",
};

function stateFromProps(ok) {
  return {
    open: false,
    submitButtonText: "Lagre",
    id: ok.id,
    paragraf: ok.paragraf,
    del: ok.del,
    belop: ok.belop,
    kortTekst: ok.kortTekst,
    langTekst: ok.langTekst,
    arkivKode: ok.arkivKode,
    aktiv: ok.aktiv,
    aktivertDato: ok.aktivertDato,
    deaktivertDato: ok.deaktivertDato,
    overtredelseGruppeId: ok.overtredelseGruppe ? ok.overtredelseGruppe.id : "",
    validationError: {},
    openDeaktiverConfirm: false,
  };
}

function OvertredelseskoderMiljogebyr({ overtredelseskoderMiljogebyr }) {
  const dispatch = useDispatch();
  const overtredelsegrupper = useSelector((state) => state.overtredelsegrupper);

  const [state, setState] = useState(() =>
    stateFromProps(overtredelseskoderMiljogebyr),
  );
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    setState((s) => ({
      ...stateFromProps(overtredelseskoderMiljogebyr),
      open: s.open,
    }));
  }, [overtredelseskoderMiljogebyr]);

  const closeModal = () =>
    setState(stateFromProps(overtredelseskoderMiljogebyr));
  const openModal = () => update({ open: true });

  const isValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePut = () => {
    update({ submitButtonText: "Lagrer..." });
    dispatch(
      putOvertredelseskoderMiljogebyr(state.id, {
        paragraf: state.paragraf,
        del: state.del,
        belop: state.belop && Number(state.belop),
        kortTekst: state.kortTekst,
        langTekst: state.langTekst,
        arkivKode: state.arkivKode,
        overtredelseGruppeId: state.overtredelseGruppeId,
        aktivertDato: state.aktivertDato,
        deaktivertDato: state.deaktivertDato,
      }),
    )
      .then(() => closeModal())
      .catch(() => update({ submitButtonText: "Lagre" }));
  };

  const saveAndClose = () => {
    if (isValid() && !state.deaktivertDato) {
      handlePut();
    } else if (isValid() && state.deaktivertDato) {
      update({ open: false, openDeaktiverConfirm: true });
    }
  };

  const handleChange = (e) => {
    const draft = { ...state, [e.target.name]: e.target.value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <>
      <ModalGeneric
        modalTitle="Rediger overtredelseskoder ileggelser"
        open={state.open}
        closeModal={closeModal}
        openModal={openModal}
        OpenModalComponent={UpdateOpenModal}
        submit={saveAndClose}
        submitButtonText={state.submitButtonText}
      >
        <OvertredelseskoderMiljogebyrUpdateModalContent
          id={state.id}
          paragraf={state.paragraf}
          del={state.del}
          belop={state.belop}
          kortTekst={state.kortTekst}
          langTekst={state.langTekst}
          arkivKode={state.arkivKode}
          aktiv={state.aktiv}
          aktivertDato={state.aktivertDato}
          deaktivertDato={state.deaktivertDato}
          overtredelseGruppeId={state.overtredelseGruppeId}
          overtredelseGrupper={overtredelsegrupper}
          validationError={state.validationError}
          handleChange={handleChange}
          actionType="update"
        />
      </ModalGeneric>
      <ModalGeneric
        modalTitle="Deaktiver overtredelseskode"
        open={state.openDeaktiverConfirm}
        closeModal={() => update({ openDeaktiverConfirm: false, open: true })}
        submit={handlePut}
        submitButtonText={state.submitButtonText}
      >
        <p>Vil du deaktivere overtredelseskode {state.id}?</p>
      </ModalGeneric>
    </>
  );
}

export default OvertredelseskoderMiljogebyr;
